var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667C8.637 2.667 2.666 8.637 2.666 16S8.636 29.333 16 29.333c7.363 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667Zm7.619 7.55-1.214 1.164a.353.353 0 0 0-.137.34v8.562c-.021.13.03.262.137.339l1.19 1.164v.259H17.62v-.247l1.23-1.194c.121-.122.121-.158.121-.34v-6.928l-3.422 8.679h-.462l-3.982-8.679v5.819a.793.793 0 0 0 .223.666l1.601 1.938v.259H8.381v-.26l1.601-1.936a.778.778 0 0 0 .208-.667v-6.726a.577.577 0 0 0-.193-.497l-1.423-1.715v-.259h4.42l3.41 7.486 3.004-7.48h4.21v.253Z",
    fill: "#6C727E"
  })));
};
export default SvgMedium;